import { List } from "antd";
import styled from "styled-components";
import { device } from "../../../../globalStyles";

import { NotificationType } from "../../Enums/NotificationType";

interface CircleProps {
    type: NotificationType;
    read: boolean;
}
export const Circle = styled.div`
    height: 12px;
    min-height: 12px;
    width: 12px;
    min-width: 12px;
    border-radius: 50%;
    margin: 0 1rem;

    border: ${({type, read}: CircleProps) => {
        let borderColor = "#c4c4c4";
        if (read) {
            return `1px solid ${borderColor}`;
        }
        switch (type){
            case NotificationType.MatchReportComplete:
            case NotificationType.MobilyticsReportComplete: {
                borderColor = "#2b8b49";
                break;
            }
        }
        return `1px solid ${borderColor}`;
    }};

    background-color: ${({type, read}: CircleProps) => {
        let backgroundColor = "#e4e4e4";
        if (read) {
            return `${backgroundColor}`;
        }
        switch (type){
            case NotificationType.MatchReportComplete:
            case NotificationType.MobilyticsReportComplete: {
                backgroundColor = "#1ce180";
                break;
            }
        }
        return `${backgroundColor}`;
    }};
`;

export const StyledModalHeader = styled.div`
    display: flex;
    align-items: center;
    height: 50px;
    background-color: #f5f5f5;
    padding: 0 4.5rem 0 1.5rem;
`;

export const StyledModalFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 46px;
`;

export const NotificationsEmptyWrapper = styled.div`
    text-align: center;
    padding: 5rem;
    border: 1px solid #f5f5f5;
    color: #424242;
`;

export const StyledUl = styled.ul`
    margin: 0;
    list-style-type: none;
    & li {
        cursor: pointer;
        margin-bottom: 10px;
        transition: .3s ease opacity;
    }
    & li.disabled {
        cursor: not-allowed;
        opacity: .5;
    }
`;

export const StyledList = styled(List)`
    .ant-list-item {
        justify-content: flex-start !important;
    }
    ${device.tablet} {
        padding-bottom: 20px;
    }
`;

interface NotificationWrapperProps {
    isRead: boolean;
    type: NotificationType;
}
export const NotificationIconWrapper = styled.div`
    height: 42px;
    min-height: 42px;
    width: 42px;
    min-width: 42px;
    margin-right: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    position: relative;

    border: ${({type, isRead}: NotificationWrapperProps) => {

        let borderColor = "#c4c4c4";
        if (isRead) {
            return `1px solid ${borderColor}`;
        }

        switch (type){
            case NotificationType.MatchReportComplete:
            case NotificationType.MobilyticsReportComplete: {
                borderColor = "#2b8b49";
                break;
            }
            case NotificationType.MatchReportPending:
            case NotificationType.MobilyticsReportPending:
            case NotificationType.MatchReportRunning:
            case NotificationType.MobilyticsReportRunning: {
                borderColor = "#e5aa43";
                break;
            }
            default: {
                borderColor = "#c4c4c4";
                break;
            }
        }

        return `1px solid ${borderColor}`;
    }};

    background-color: ${({type, isRead}: NotificationWrapperProps) => {

        const backgroundColor = "#fff";
        if (isRead) {
            return `${backgroundColor}`;
        }

        switch (type){
            case NotificationType.MatchReportPending:
            case NotificationType.MobilyticsReportPending:
            case NotificationType.MatchReportRunning:
            case NotificationType.MobilyticsReportRunning:
            case NotificationType.MatchReportCaching:
            case NotificationType.MobilyticsReportCaching: {
                return "#e5aa43";
            }
            default: {
                return "#fff";
            }
        }
    }};
`;

interface DateTimeTextProps {
    isRead: boolean;
}
export const DateTimeText = styled.div`
    font-size: 12px;
    min-width: 100px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-weight: ${({isRead}: DateTimeTextProps) => !isRead ? "bold" : "initial"};
    color: ${({isRead}: DateTimeTextProps) => !isRead ? "#2b8b49" : "inherit"};
`;

interface TitleTextProps {
    type: NotificationType;
    isRead: boolean;
}
export const TitleText = styled.div`
    font-weight: bold;
    max-width: 312px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${({type, isRead}: TitleTextProps) => {

        let color = "#2e3d49";
        if (isRead) {
            return color;
        }

        switch (type){
            case NotificationType.MatchReportComplete:
            case NotificationType.MobilyticsReportComplete: {
                color = "#2b8b49";
                break;
            }
            case NotificationType.MatchReportError:
            case NotificationType.MobilyticsReportError: {
                color = "#e02020";
                break;
            }
        }

        return color;
    }};
`;

export const DeleteConfirmWrapper = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 171px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-shadow: inset 2px 0 5px 0 rgba(0, 0, 0, 0.5);
    border: 1px solid #c4c4c4;
    background-color: #f3f5f7;
`;

interface ErrorExclamationProps {
    isRead: boolean;
}
export const ErrorExclamation = styled.div`
    background-color: #e02020;
    border-radius: 50%;
    height: 20px;
    width: 20px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -7px;
    right: -7px;
    opacity: ${({isRead}: ErrorExclamationProps) => isRead ? ".65" : "initial"};
`;
